import React, { useState } from 'react';
import { useSandboxArchive } from '../../views/hooks/useOntologyViews';
import { useSandboxSession } from '../SandboxSessionContext';
import { publicationError } from '../../approvals/publicationError';

/** Archive a branch; a change still awaiting approval is declined the same way. */
export default function BranchReviewArchive({ branchId, pendingApproval = false }) {
  const [confirming, setConfirming] = useState(false);
  const archive = useSandboxArchive();
  const { previewSandboxId, clearPreview } = useSandboxSession();
  const submit = async () => {
    try {
      await archive.mutateAsync({ sandboxId: branchId });
      if (previewSandboxId === branchId) clearPreview();
      setConfirming(false);
    } catch {
      /* The mutation error stays beside the confirmation. */
    }
  };
  return (
    <div className="text-xs text-cyan-900">
      {confirming ? (
        <div className="flex flex-wrap items-center gap-3">
          <span>
            {pendingApproval
              ? 'Decline this proposal? It will leave your proposed changes.'
              : 'Discard this proposal? It will no longer be available to preview.'}
          </span>
          <button
            disabled={archive.isPending}
            onClick={submit}
            className="font-semibold text-rose-700 disabled:opacity-40"
          >
            {pendingApproval ? 'Confirm decline' : 'Confirm discard'}
          </button>
          <button disabled={archive.isPending} onClick={() => setConfirming(false)}>
            Cancel
          </button>
        </div>
      ) : (
        <button onClick={() => setConfirming(true)} className="rounded-lg px-2 py-2 font-medium text-cyan-900 hover:bg-cyan-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700">
          {pendingApproval ? 'Decline' : 'Discard proposal'}
        </button>
      )}
      {archive.error && (
        <p role="alert" className="mt-2 text-rose-700">
          {publicationError(archive.error.message)}
        </p>
      )}
    </div>
  );
}
